export class WebhookV1StandardPayloadJobMetricsReportFailed {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadJobMetricsReportFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadJobMetricsReportFailed.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum;
(function (WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum) {
    WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum["JobMetricsReportFailed"] = "JOB_METRICS_REPORT_FAILED";
})(WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum || (WebhookV1StandardPayloadJobMetricsReportFailedTypeEnum = {}));
